import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { getOverallQuestion } from 'global/js/helpers';
import * as Actions from 'containers/Home/actions';
import * as tdActions from './actions';
import CheckboxWithLabel from "components/CheckboxWithLabel/CheckboxWithLabel";
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import ScaleRadioButtonList from 'components/ScaleRadioButtonList/ScaleRadioButtonList';
import StarRadioButtonList from 'components/StarRadioButtonList/StarRadioButtonList';
import TextArea from 'components/TextArea/TextArea';
import './TD.scss';

class TD extends Component {
    constructor(props) {
        super(props);

        this.tdPageNumber = parseInt(this.props.match.params.tdPageNumber);
        this.numTdPages = parseInt(this.props.match.params.numTdPages);
    }

    /**
     * Checks for any additional TD questions, and returns the link to the
     * next question, or to the overall additional page.
     */
    getNextPage = () => {
        const isLast = this.tdPageNumber === this.numTdPages;

        return isLast ? '/TC' : `/TD/${this.tdPageNumber + 1}/${this.numTdPages}`;
    }

    /**
     * Gets the TD question specified by the position in the props. So, if the
     * position is 1 it will grab the first TD question, 2 the second, etc.
     */
    getTdQuestion = () => {
        let tdIndex = 0;

        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions) {
            // Increment the count after each TD we check.
            if (question.Type.toLowerCase().includes('tourdirector')) tdIndex++;
            // Return the TD question at the requested index.
            if (tdIndex === this.tdPageNumber) return question;
        }
    }

    /**
     * Checks for any TD questions, and returns the link to the previous 
     * TD question. When we get to the beginning, it return the TE page.
     */
    getPrevPage = () => {
        const isFirst = this.tdPageNumber === 1;

        return isFirst ? '/TE' : `/TD/${this.tdPageNumber - 1}/${this.numTdPages}`;
    }

	/**
	 * Called when there is a change to the text area value. 
     * Handles updating the text value state.
	 *
	 * @param {String} : comment
	 */
    handleChange = (comment) => {
        this.props.tdActions.setOverallAnswer({
            type: 'TourDirector',
            comment: comment,
            tdIndex: this.tdPageNumber
        });
    }

    /**
     * Called when there is a change to the NA option
     */
    handleNaOption = () => {
        this.props.tdActions.setOverallAnswer({
            type: 'TourDirector',
            isNotApplicable: true,
            tdIndex: this.tdPageNumber
        });
    }

    render() {
        const { actions, individualID, match, prodTourID, surveyData, tdActions } = this.props;
        this.tdPageNumber = parseInt(match.params.tdPageNumber);
        this.numTdPages = parseInt(match.params.numTdPages);
        const nextLink = this.getNextPage();
        const prevLink = this.getPrevPage();
        const question = this.getTdQuestion();
        const { Answer, AnswerType, IsNotApplicableEligible, NotApplicableText, SubText, Text, Type } = question;
        const isFourScale = AnswerType.toLowerCase().includes('4 scale');
        const defaultTextValue = ''; // Use instead of null which does not cause a re-render.
        const tdClasses = classNames('wrapper td', {
            'disabled': Answer.IsNotApplicable
        });

        return (
            <section className={tdClasses}>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>
                    
                    <div className='content'>
                        <Question questionText={Text} />

                        {IsNotApplicableEligible &&
                            <CheckboxWithLabel
                                id={'tdCheckbox'}
                                isChecked={Answer.IsNotApplicable}
                                labelText={NotApplicableText}
                                name={'n/a option'}
                                handleClick={this.handleNaOption}
                            />
                        }
						
                        {(isFourScale ? 
                            <ScaleRadioButtonList
                                answerValue={Answer.AnswerRating}
                                handleClick={tdActions.setOverallAnswer}
                                isFourScale={true}
                                questionType={Type}
                                tdIndex={this.tdPageNumber}
                            /> :
                            <StarRadioButtonList
                                answerValue={Answer.AnswerRating}
                                handleClick={tdActions.setOverallAnswer}
                                tdIndex={this.tdPageNumber}
                                questionType={Type}
                            />
                        )}

                        <Question questionText={SubText} />

                        <TextArea
                            handleChange={this.handleChange}
                            textValue={Answer.AnswerComment || defaultTextValue}
                        />

                        <Navigation
                            actions={actions}
                            answerValue={Answer.AnswerRating}
                            individualID={individualID}
                            isNotApplicable={Answer.IsNotApplicable}
                            isOverall={true}
                            locationIndex={2}
                            nextLink={nextLink}
                            prevLink={prevLink}
                            prodTourID={prodTourID}
                            surveyData={surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        tdActions: bindActionCreators(tdActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TD));



// WEBPACK FOOTER //
// ./application/containers/TD/TD.jsx